import { render, staticRenderFns } from "./ProfileRichTextEditor.vue?vue&type=template&id=15924a8b&scoped=true"
import script from "./ProfileRichTextEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileRichTextEditor.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileRichTextEditor.vue?vue&type=style&index=0&id=15924a8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15924a8b",
  null
  
)

export default component.exports